import { render, staticRenderFns } from "./AuthBackground.vue?vue&type=template&id=49c47feb&scoped=true"
import script from "./AuthBackground.vue?vue&type=script&lang=js"
export * from "./AuthBackground.vue?vue&type=script&lang=js"
import style0 from "./AuthBackground.vue?vue&type=style&index=0&id=49c47feb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c47feb",
  null
  
)

export default component.exports